import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useColorModeValue,
} from "@chakra-ui/react";
import PayeeDetails from "./PayeeDetails";

const PayeeDetailsModal = ({ isOpen, onClose, payee }) => {
  const overlayBg = useColorModeValue(
    "rgba(0, 0, 0, 0.6)",
    "rgba(0, 0, 0, 0.8)"
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay bg={overlayBg} backdropFilter="blur(10px)" />
      <ModalContent bg="transparent" boxShadow="none" overflow="hidden">
        <ModalHeader p={0} />
        <ModalCloseButton
          zIndex={1}
          color="white"
          bg="rgba(0, 0, 0, 0.5)"
          borderRadius="full"
          _hover={{ bg: "rgba(0, 0, 0, 0.7)" }}
        />
        <ModalBody p={6}>
          <PayeeDetails payee={payee} onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PayeeDetailsModal;
